export enum FinancialAdjustmentNone {
    NONE = 'None'
}
